<template>
  <div class="p-message-edit p-message-edit--message-action">
    <div class="c-title">
      <div class="c-title__text u-fs24">メッセージの動作・日程を設定する</div>
    </div>
    <div class="p-message-edit-list">
      <div class="p-message-edit-list__item">
        <div class="c-radio">
          <div class="c-radio__title">通知動作を設定する</div>
          <ul class="c-radio-list">
            <li class="c-radio-list__item u-w100p">
              <label class="c-radio__label">
                <input
                  v-model="requireInteraction"
                  type="radio"
                  name="push_action"
                  value="0"
                />
                <div class="c-radio__item">
                  <div class="c-radio__box"></div>
                  <div class="c-radio__box-label">一定時間後に自動最小化</div>
                </div>
              </label>
            </li>
            <li class="c-radio-list__item">
              <label class="c-radio__label">
                <input
                  v-model="requireInteraction"
                  type="radio"
                  name="push_action"
                  value="1"
                />
                <div class="c-radio__item">
                  <div class="c-radio__box"></div>
                  <div class="c-radio__box-label">ユーザーがアクションを起こすまで表示</div>
                </div>
              </label>
            </li>
          </ul>
          <div class="c-error">
            <div class="c-error__text"></div>
          </div>
        </div>
      </div>
      <div class="p-message-edit-list__item p-message-edit-list__item--set-delivery-action">
        <div class="c-radio">
          <div class="c-radio__title">配信する日程を設定する</div>
          <label class="c-radio__label">
            <input
              v-model="deliverType"
              type="radio"
              name="push_timing"
              value="1"
            />
            <div class="c-radio__item">
              <div class="c-radio__box"></div>
              <div class="c-radio__box-label">予約</div>
            </div>
          </label>
        </div>
        <div v-show="deliverType == '1'" class="c-input u-w220">
          <datepicker
            ref="refDeliveryDate"
            v-model="sendStartDate"
            name="delivery_date"
            format="yyyy/MM/dd"
            placeholder="YYYY/MM/DD"
            input-class="c-input__item c-input__item--overlay-ico"
            calendar-class="datepicker_calendar"
            :language="ja"
            :highlighted="highlightedDates"
          />
          <div class="c-input__icon c-input__icon--overlay" @click="showCalendar('delivery_date')">
            <div class="c-icon c-icon--white u-wh22">
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <use xlink:href="/assets/img/sprite.svg#calendar" />
              </svg>
            </div>
          </div>
          <input type="hidden" name="send_start_date" />
          <div class="c-error c-error--balloon c-error--date">
            <div class="c-error__text"></div>
          </div>
        </div>
        <div v-show="deliverType == '1'" class="c-select-time u-w220">
          <timepicker
            ref="timeSelect"
            v-model="sendStartTime"
            format="HH:mm"
            hour-label="時"
            minute-label="分"
            name="time_select"
            placeholder="時間設定"
            advanced-keyboard
            manual-input
            auto-scroll
            :model-value="sendStartTime"
          />
          <div class="c-error c-error--balloon c-error--time">
            <div class="c-error__text"></div>
          </div>
        </div>
      </div>
      <div v-if="!skipRegular" class="p-message-edit-list__item p-message-edit-list__item--set-delivery-action">
        <div class="c-radio">
          <label class="c-radio__label">
            <input
              v-model="deliverType"
              type="radio"
              name="push_timing"
              value="3"
            />
            <div class="c-radio__item">
              <div class="c-radio__box"></div>
              <div class="c-radio__box-label">定期配信</div>
            </div>
          </label>
        </div>
        <!-- 配信曜日の選択 -->
        <div v-show="deliverType == '3'" class="c-select-week">
          <div class="c-select-week__title u-w70">曜日設定</div>
          <ul class="c-select-week-list">
            <li class="c-select-week-list__item">
              <label class="c-select-week__label">
                <input
                  v-model="regularType"
                  type="checkbox"
                  name="delivery_schedule_week"
                  value="0"
                />
                <div class="c-select-week__item">日</div>
              </label>
            </li>
            <li class="c-select-week-list__item">
              <label class="c-select-week__label">
                <input
                  v-model="regularType"
                  type="checkbox"
                  name="delivery_week"
                  value="1"
                />
                <div class="c-select-week__item">月</div>
              </label>
            </li>
            <li class="c-select-week-list__item">
              <label class="c-select-week__label">
                <input
                  v-model="regularType"
                  type="checkbox"
                  name="delivery_week"
                  value="2"
                />
                <div class="c-select-week__item">火</div>
              </label>
            </li>
            <li class="c-select-week-list__item">
              <label class="c-select-week__label">
                <input
                  v-model="regularType"
                  type="checkbox"
                  name="delivery_week"
                  value="3"
                />
                <div class="c-select-week__item">水</div>
              </label>
            </li>
            <li class="c-select-week-list__item">
              <label class="c-select-week__label">
                <input
                  v-model="regularType"
                  type="checkbox"
                  name="delivery_week"
                  value="4"
                />
                <div class="c-select-week__item">木</div>
              </label>
            </li>
            <li class="c-select-week-list__item">
              <label class="c-select-week__label">
                <input
                  v-model="regularType"
                  type="checkbox"
                  name="delivery_week"
                  value="5"
                />
                <div class="c-select-week__item">金</div>
              </label>
            </li>
            <li class="c-select-week-list__item">
              <label class="c-select-week__label">
                <input
                  v-model="regularType"
                  type="checkbox"
                  name="delivery_week"
                  value="6"
                />
                <div class="c-select-week__item">土</div>
              </label>
            </li>
          </ul>
          <div class="c-error c-error--balloon c-error--week">
            <div class="c-error__text"></div>
          </div>
        </div>

        <div v-show="deliverType == '3'" class="c-select-time">
          <div class="c-select__title u-w70">時間設定</div>
          <timepicker
            ref="regularTimeSelect"
            v-model="targetStartTime"
            class="u-w220"
            format="HH:mm"
            hour-label="時"
            name="regular_time_select"
            minute-label="分"
            placeholder="時間設定"
            advanced-keyboard
            manual-input
            auto-scroll
          />
          <div class="c-error c-error--balloon c-error--week-time">
            <div class="c-error__text"></div>
          </div>
        </div>

        <div v-show="deliverType == '3'" class="c-input">
          <div class="c-input__title u-w70">配信開始</div>
        </div>
        <div v-show="deliverType == '3'" class="c-input">
          <datepicker
            ref="refDeliveryScheduleDateFrom"
            v-model="regularStartDate"
            name="delivery_schedule_date_from"
            format="yyyy/MM/dd"
            placeholder="YYYY/MM/DD"
            input-class="c-input__item c-input__item--overlay-ico u-w220"
            calendar-class="datepicker_calendar"
            :language="ja"
            :highlighted="highlightedDates"
          />
          <div class="c-input__icon c-input__icon--overlay" @click="showCalendar('delivery_schedule_date_from')">
            <div class="c-icon c-icon--white u-wh22">
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <use xlink:href="/assets/img/sprite.svg#calendar" />
              </svg>
            </div>
          </div>
          <input type="hidden" name="regular_start_date" />
          <div class="c-error c-error--balloon c-error--date-from">
            <div class="c-error__text"></div>
          </div>
        </div>
        <div v-show="deliverType == '3'" class="c-input">
          <div class="c-input__title u-w70">終了</div>
        </div>
        <div v-show="deliverType == '3'" class="c-input">
          <datepicker
            ref="refDeliveryScheduleDateTo"
            v-model="regularEndDate"
            name="delivery_schedule_date_to"
            format="yyyy/MM/dd"
            placeholder="YYYY/MM/DD"
            input-class="c-input__item c-input__item--overlay-ico u-w220"
            calendar-class="datepicker_calendar"
            :language="ja"
            :highlighted="highlightedDates"
          />
          <div class="c-input__icon c-input__icon--overlay" @click="showCalendar('delivery_schedule_date_to')">
            <div class="c-icon c-icon--white u-wh22">
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <use xlink:href="/assets/img/sprite.svg#calendar" />
              </svg>
            </div>
          </div>
          <input type="hidden" name="regular_end_date" />
          <div class="c-error c-error--balloon c-error--date-to">
            <div class="c-error__text"></div>
          </div>
        </div>
      </div>
      <div v-show="!skipImmediate" class="p-message-edit-list__item p-message-edit-list__item--set-delivery-action">
        <div class="c-radio">
          <label class="c-radio__label">
            <input
              v-model="deliverType"
              type="radio"
              name="push_timing"
              value="4"
            />
            <div class="c-radio__item">
              <div class="c-radio__box"></div>
              <div class="c-radio__box-label">メッセージ作成後に即時配信</div>
            </div>
          </label>
          <div class="c-error">
            <div class="c-error__text"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from '../molecules/Datepicker.vue';
const ja = 'ja';
import VueTimepicker from 'vue3-timepicker'
import 'vue3-timepicker/dist/VueTimepicker.css'
import moment from 'moment';

export default {
  components: {
    'datepicker': Datepicker,
    'timepicker': VueTimepicker,
  },
  props: {
    modelValue: Object,
    skipRegular: {
      type: Boolean,
      default: false
    },
    skipImmediate: {
      type: Boolean,
      default: false
    },
  },
  emits: ['update:modelValue'],
  data: function () {
    return {
      ja:ja,
      highlightedDates: {
        customPredictor: (date) => {
          const today = new Date();
          const targetDate = new Date(date);
          return (
            today.getFullYear() === targetDate.getFullYear() &&
            today.getMonth() === targetDate.getMonth() &&
            today.getDate() === targetDate.getDate()
          );
        },
        color: '#209bb9'
      },
    };
  },
  computed: {
    requireInteraction: {
      get() {
        return this.modelValue.requireInteraction;
      },
      set(requireInteraction) {
        this.updateValue({
          requireInteraction
        });
      }
    },
    deliverType: {
      get() {
        return this.modelValue.deliverType;
      },
      set(deliverType) {
        this.updateValue({
          deliverType
        });
      }
    },
    sendStartDate: {
      get() {
        return this.modelValue.sendStartDate;
      },
      set(sendStartDate) {
        this.updateValue({
          sendStartDate
        });
      }
    },
    sendStartTime: {
      get() {
        return this.modelValue.sendStartTime;
      },
      set(sendStartTime) {
        if (typeof(sendStartTime) == 'string') {
          this.updateValue({
            sendStartTime
          });
        } else if (typeof(sendStartTime) == 'object' && sendStartTime.HH) {
          if (!sendStartTime.mm) {
            sendStartTime.mm = '00'
          }
          this.updateValue({
            sendStartTime: `${sendStartTime.HH}:${sendStartTime.mm}`
          });
        }
      }
    },
    regularType: {
      get() {
        return this.modelValue.regularType;
      },
      set(regularType) {
        this.updateValue({
          regularType
        });
      }
    },
    regularStartDate: {
      get() {
        return this.modelValue.regularStartDate;
      },
      set(regularStartDate) {
        this.updateValue({
          regularStartDate
        });
      }
    },
    regularEndDate: {
      get() {
        return this.modelValue.regularEndDate;
      },
      set(regularEndDate) {
        this.updateValue({
          regularEndDate
        });
      }
    },
    targetStartTime: {
      get() {
        return this.modelValue.targetStartTime;
      },
      set(targetStartTime) {
        if (typeof(targetStartTime) == 'string') {
          this.updateValue({
            targetStartTime
          });
        } else if (typeof(targetStartTime) == 'object' && targetStartTime.HH) {
          if (!targetStartTime.mm) {
            targetStartTime.mm = '00'
          }
          this.updateValue({
            targetStartTime: `${targetStartTime.HH}:${targetStartTime.mm}`
          });
        }
      }
    },
  },
  methods: {
    updateValue(target) {
      // 親のv-modelを更新
      this.$emit('update:modelValue', {
        ...this.modelValue,
        ...target
      })
    },
    onTimeSelect: function(selected) {
      this.sendStartTime = selected;
    },
    onRegularTimeSelect: function(selected) {
      this.targetStartTime = selected;
    },
    showCalendar: function(name) {
      const list = {
        delivery_date: 'refDeliveryDate',
        delivery_schedule_date_from: 'refDeliveryScheduleDateFrom',
        delivery_schedule_date_to: 'refDeliveryScheduleDateTo',
        delivery_end_date_to: 'refDeliveryEndDateTo',
      };
      Object.keys(list).forEach((key, _index) => {
        if (!this.$refs[list[key]]) return;
        if (name == key) {
          this.$refs[list[key]].$el.querySelector('input').focus();
          this.$refs[list[key]].showCalendar();
        } else {
          this.$refs[list[key]].close(true);
        }
      })
    },
    validate: function(errors) {
      if(this.deliverType == 1){
        if(!this.sendStartDate){
          errors['send_start_date'] = '日付を入力してください';
        }
        if(!this.timeIsValid(this.sendStartTime)){
          errors['time_select'] = '時間を選択してください';
        }
        let sendStartDate = moment(this.sendStartDate).format('YYYY-MM-DD') + ' ' + this.sendStartTime + ':00';
        if (moment(sendStartDate) < moment()) {
          errors['send_start_date'] = '過去の時間が指定されています';
        }
      } else if(this.deliverType == 3){
        if(this.regularType.length == 0){
          errors['delivery_schedule_week'] = '曜日を入力してください';
        }
        if(!this.timeIsValid(this.targetStartTime)){
          errors['regular_time_select'] = '時間を入力してください';
        }
        if(!this.regularStartDate){
          errors['regular_start_date'] = '日付を入力してください';
        }
        if(this.regularEndDate && this.regularStartDate > this.regularEndDate){
          errors['regular_start_date'] = '配信開始日に終了日よりも未来の日付を指定しています';
        }
        const sendStartDate = moment(this.regularStartDate).format('YYYY-MM-DD') + ' ' + this.targetStartTime + ':00';
        const sendEndDate = moment(this.regularEndDate).format('YYYY-MM-DD') + ' ' + this.targetStartTime + ':00';
        if (moment(sendStartDate) < moment() && moment(sendEndDate) < moment()){
          errors['regular_start_date'] = '配信開始日と終了日に過去の日付を指定しています';
        }
      }
    },
  },
}
</script>
